export default __webpack_public_path__ + "static/media/spinner.9cddf574.svg";